import { FunctionComponent, useState, useEffect } from 'react';
import { Typography, Table, TableCell, TableRow } from '../../tailwindcomponents';
import TasksApi from '../../api/tasks';
import { Part } from '../../types/tasks';

type PartDetailsProps = {
    taskBarcode: string
}

const PartDetails: FunctionComponent<PartDetailsProps> = ({ taskBarcode }) => {

    const [parts, setParts] = useState<Part[]>([]);
    useEffect(() => {
        TasksApi.GetAllPartsByTaskBarcode(taskBarcode).then(res => {
            if (res.status === true)
                setParts(res.data);
            else {
                setParts([]);
            }
        })
    }, [taskBarcode])

    const generateTableBody = (row: Part, index: number) => {
        return (
            <TableRow >
                <TableCell>{index}</TableCell>
                <TableCell>{row.part_request_barcode}</TableCell>
                <TableCell>{row.part_number}</TableCell>
                <TableCell>{row.part_description}</TableCell>
                <TableCell>{row.part_serial_number}</TableCell>
                <TableCell>{row.part_requested_amount}</TableCell>
                <TableCell>{row.part_status}</TableCell>
                <TableCell>{row.estimated_arrival_date_string}</TableCell>
            </TableRow>
        )
    }

    return (
        <div className="w-full content-center items-center">
            <div>
                <Typography text={`Parts(${parts.length})`} variant='h2' align='center' margin={[2, 0, 2, 0]} />
                {parts.length > 0 &&
                    <Table
                        headers={["Req", "PN", "Description", "SN", "Qty", "Status", "ETA"]}
                        rows={parts}
                        generateBody={(row: any, index: number) => generateTableBody(row, index)}
                        pagination={false}
                        skipIndexCol={false}
                    />
                }
            </div>
        </div>
    );
};
export default PartDetails;
